@for (category of categories; track $index) {
<ul>
  <mat-checkbox
    [(ngModel)]="category.checked"
    [indeterminate]="category.isIndeterminate"
    (ngModelChange)="onCheckChanged(category)"
    [disabled]="disabled"
    >{{category.name}}</mat-checkbox
  >
  @for (child of category.children; track $index) {
  <li>
    <mat-checkbox
      [(ngModel)]="child.checked"
      (ngModelChange)="onCheckChanged(child,category)"
      [disabled]="disabled"
      >{{child.name}}</mat-checkbox
    >
  </li>
  }
</ul>
}
